import { Box } from '@mui/material'

import CustomModal from '../../../../Theme/Modal'
import JudgesForm from '../JudgesForm/JudgesForm'

export const JudgesModal = ({ showModal, setShowModal, contestId, judges, ownerId, contest }) => {
  const handleClose = () => setShowModal(false)

  return (
    <CustomModal
      open={showModal}
      onClose={handleClose}
      width={600}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      title={'Contest Judges'}
    >
      <Box>
        <JudgesForm
          isModal
          contestId={contestId}
          judges={judges}
          ownerId={ownerId}
          contest={contest}
        />
      </Box>
    </CustomModal>
  )
}
